import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { QuickFixStepModel } from '@shared/es-mutual/interfaces';
import { EsOcrQuickFixService } from '@shared/es-mutual/services';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-es-ocr-quick-fix-header',
  templateUrl: './es-ocr-quick-fix-header.component.html',
  styleUrls: ['./es-ocr-quick-fix-header.component.scss'],
})
export class EsOcrQuickFixHeaderComponent implements OnInit {
  @Output() public clearAll: EventEmitter<void> = new EventEmitter<void>();
  @Output() public quickFix: EventEmitter<void> = new EventEmitter<void>();

  public stepsToFix: QuickFixStepModel[] = [];

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(private esOcrQuickFixService: EsOcrQuickFixService) {}

  ngOnInit(): void {
    this.esOcrQuickFixService.stepsChanged$.pipe(takeUntil(this.destroy$)).subscribe((stepsState) => {
      const stepsToFix = stepsState.current;
      this.stepsToFix = stepsToFix;
    });
  }

  public onClearAll() {
    this.clearAll.emit();
  }

  public onQuickFix() {
    this.quickFix.emit();
  }
}
